





























import {Component, Vue} from 'vue-property-decorator';
import Scroll from "@/components/Scroll.vue";
import Project, {ProjectData} from "@/components/Project.vue";
import projects from "./res/projects.json"

@Component({
    components: {Project, Scroll}
})
export default class App extends Vue
{
    projects: ProjectData[] = projects;
}
